/* eslint-disable react/prop-types */
import SplashBannerComponent from "./splash-banner";
function SplashBanner({ home, onFindOutClick }) {
  return <SplashBannerComponent home={home} onFindOutClick={onFindOutClick} />;
}

export default SplashBanner;
